import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/universe/index.vue')
const Intro = () => import('../activity/universe/Intro.vue')

export const IndexRoute: RouteConfig = {
  path: '/activity/universe',
  name: 'activity_universe',
  component: Index,
  meta: {
    title: '运动元宇宙',
  },
}

export const IntroRoute: RouteConfig = {
  path: '/activity/universe-intro',
  name: 'activity_universe_intro',
  component: Intro,
  meta: {
    title: '详细攻略',
  },
}

export default [IndexRoute, IntroRoute]
